<button mat-icon-button class="status-buttons">
    <mat-icon matTooltip="Check Status" (click)="checkProcessStatus($event)" class="status-mat-icons">info</mat-icon>
</button>
